
export default class anchorLink {
  constructor() {
    this.init();
  }

  getHeaderHeight() {
    const header = document.querySelector('.l-header');
    return header?.offsetHeight ?? 0;
  }
  
  init(){
    document.addEventListener('DOMContentLoaded', () => {
      const getHeaderHeight = this.getHeaderHeight.bind(this);
      const openSpecialAccordion = this.openSpecialAccordion.bind(this);

      const topLink = document.querySelector('.js-return-top');
      const gimmick = document.querySelectorAll('.js-gimmick');

      //ページTOPに戻る処理
      if (topLink) {
        topLink.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });

        let gimmickObserver = null;
        const setupGimmickObserver = () => {
          // 処理が走っていたら停止
          if (gimmickObserver) {
            gimmickObserver.disconnect();
            gimmickObserver = null;
            gimmick.forEach(el => el.classList.remove('is-active'));
          }

          gimmickObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-active');
                } else {
                  entry.target.classList.remove('is-active');
                }
              });
            },
            {
              threshold: 0.5
            }
          );
          gimmick.forEach(el => gimmickObserver.observe(el));
        };

        setupGimmickObserver();
      }

      //ページが読み込まれた際、URLにハッシュが含まれていればそのIDにスクロール
      const handleScroll = () => {
        const targetId = window.location.hash.replace('#', '');
        const targetEl = document.getElementById(targetId);
        if (!targetEl) return;
      
        const headerHeight = getHeaderHeight();
      
        void targetEl.offsetHeight;
        requestAnimationFrame(() => {
          const targetTop = targetEl.getBoundingClientRect().top + window.scrollY - headerHeight;
          window.scrollTo({
            top: targetTop,
            behavior: 'smooth'
          });
        });
      };
      
      const processHashTarget = () => {
        const targetId = window.location.hash.replace('#', '');
        if (targetId === 'special') {
          openSpecialAccordion(() => {
            handleScroll();
          });
        } else {
          handleScroll();
        }
      };
      
      window.addEventListener('load', processHashTarget);
      window.addEventListener('loadingComplete', processHashTarget);
      



      //ページ内リンクの処理
      document.querySelectorAll('a[href*="#"]').forEach(anchor => {
        anchor.addEventListener('click', (e) => {
          const url = new URL(anchor.href, window.location.origin);
      
          if (
            url.pathname === window.location.pathname &&
            url.hostname === window.location.hostname &&
            url.hash
          ) {
            const targetId = url.hash.slice(1);
            const targetElement = document.getElementById(targetId);

            const headerHeight = this.getHeaderHeight();
            function scrollHandler() {
              e.preventDefault();

              void targetElement.offsetHeight;

              requestAnimationFrame(() => {
                const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - headerHeight;

                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              });
            }
      
            if (targetElement) {
              scrollHandler();
            }
            
            if(targetId === 'special'){
             this.openSpecialAccordion(scrollHandler); 
            }
          }
        });
      });
    });
  }

  // #specialに遷移後、アコーディオンを開く処理
  openSpecialAccordion(callback) {
    const specialLinkCard = document.querySelector('.p-index__special_linkcard_more');
    if (specialLinkCard) {
      const trigger = specialLinkCard.closest('.js-acd_parent')?.querySelector('.js-acd_trigger');
      const acdTarget = trigger?.closest('.js-acd_parent')?.querySelector('.js-acd_target');

      if (trigger && !trigger.classList.contains('is-active')) {
        trigger.click();

        //アコーディオンの開閉が完全に終わるのを待つ
        if (acdTarget) {
          const onEnd = (e) => {
            if (e.propertyName !== 'max-height') return;
            acdTarget.removeEventListener('transitionend', onEnd);
            callback?.();
          };
          acdTarget.addEventListener('transitionend', onEnd);
        } else {
          setTimeout(() => callback?.(), 200);
        }
      } else {
        requestAnimationFrame(() => callback?.());
      }
    } else {
      callback?.();
    }
  }

}